<div class="container mt-4">
  <div class="row mb-5">
    <div *ngIf="activationEmailState == ActivateEmailStates.OngoingActivation">
      <p class="text-center">Activating your account...</p>
    </div>
    <div *ngIf="activationEmailState == ActivateEmailStates.Activated">
      <p class="text-center">Your account has been activated, you're getting redirected!</p>
    </div>
    <div *ngIf="activationEmailState == ActivateEmailStates.FailedActivation" class="text-center">
      <div [innerHTML]="failedActivationText"></div>
      <a *ngIf="failedActivationLoginButtonText" class="btn btn-primary btn-large" routerLink="/login">{{ failedActivationLoginButtonText }}</a>
    </div>
  </div>
</div>
